import APIService from './apiservice';

const createCrudService = (route) => {
	const getList = async (query, childEndpoint=null) => {
		const path = generateRequestPath(route, null, childEndpoint);
    	return APIService.doRequest(path, 'GET', query, null);
  	};

  	const getDetails = async (id, childEndpoint=null) => {  		
		const path = generateRequestPath(route, id, childEndpoint);
    	return APIService.doRequest(path, 'GET', null, null);
  	};

  	const doCreate = async (data, childEndpoint=null) => {
		const path = generateRequestPath(route, null, childEndpoint);
    	return APIService.doRequest(path, 'POST', data, null);
  	};

  	const doUpdate = async (id, data, childEndpoint=null) => {
		const path = generateRequestPath(route, id, childEndpoint);
    	return APIService.doRequest(path, 'PUT', data, null);
  	};

  	const doDelete = async (id, childEndpoint=null) => {
		const path = generateRequestPath(route, id, childEndpoint);
    	return APIService.doRequest(path, 'DELETE', null, null);
  	};
  	
  	const doImport = async (path, file) => {
	  	return APIService.doUploadRequest(`${route}/${path}`, file);
  	}
  	
  	const doPostRequest = async (endpoint, data) => {
	  	return APIService.doRequest(`${route}/${endpoint}`, 'POST', data, null);
  	}
  	
  	const doGetRequest = async (endpoint, data) => {
	  	return APIService.doRequest(`${route}/${endpoint}`, 'GET', data, null);
  	}

	const doPublicGetRequest = async (endpoint, data) => {
		return APIService.doPublicRequest(`${route}/${endpoint}`, 'GET', data);
	}

	const doPublicPostRequest = async (endpoint, data) => {
	  	return APIService.doPublicRequest(`${route}/${endpoint}`, 'POST', data);
  	}

	const getPublicList = async (query, childEndpoint=null) => {
		const path = generateRequestPath(route, null, childEndpoint);
    	return APIService.doPublicRequest(path, 'GET', query, null);
  	};

	const getPublicDetails = async (id, childEndpoint=null) => {  		
		const path = generateRequestPath(route, id, childEndpoint);
    	return APIService.doPublicRequest(path, 'GET', null, null);
  	};

	const doPostRequestWithFile = async (endpoint, data) => {
	  	return APIService.doRequestWithFile(`${route}/${endpoint}`, 'POST', data, null);
  	}

	const generateRequestPath = (route, id=null, childEndpoint=null) => {
		let path = route;
		path += childEndpoint ? `/${childEndpoint}` : '';
		
		if(id !== null ){
			path += `/${id > 0 ? id : 'create'}`;
		}
		return path;
	}


  	return {
	    getList,
	    getDetails,
	    doCreate,
	    doUpdate,
	    doDelete,
	    doImport,
	    doPostRequest,
	    doGetRequest,
		doPublicGetRequest,
		doPublicPostRequest,
		getPublicList,
		getPublicDetails,
		doPostRequestWithFile,	

  	};
};

export default createCrudService;